<div id="browsingSubjects">
    <div class="container">
        <div class="row-auto subject-list-items justify-content-center">
            <ng-container *ngFor="let subject of subjects">
                <div
                    class="subjects-list-item col-6 col-sm-4 col-md-4 col-lg-2"
                    *ngIf="subject.resultsCount"
                >
                    <a
                        id="selenium-subject-{{ subject.id }}"
                        [routerLink]="subject.getBrowseURL()"
                        queryParamsHandling="merge"
                        class="{{ gtmPrefix + 'subject-name' }}"
                        [attr.data-gtmlabel]="subject.title"
                    >
                        <div class="subject-image">
                            <img
                                src="{{ subject.posterImage }}"
                                alt="{{ subject.posterImageAltText }}"
                            />
                        </div>
                        {{ subject.title }}
                    </a>
                </div>
            </ng-container>
        </div>
    </div>
</div>
